import useAuth from "hooks/useAuth"
import React from "react"
import { Navigate } from "react-router-dom"
import PropTypes from "prop-types"

const Authmiddleware = props => {
  const { userData } = useAuth()

  if (!userData) {
    return (
      <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
    )
  }
  return <React.Fragment>{props.children}</React.Fragment>
}
Authmiddleware.propTypes = {
  location: PropTypes.string,
  children: PropTypes.element,
}
export default Authmiddleware
